// Typelizer digest 567230551d147e5fbfcc8e6227864782
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/invoices/:invoice_id/issue */
  create: (
    params: { invoiceId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/invoices/:invoice_id/issue', params, options),
    method: 'post',
  }),
}
